export default __webpack_public_path__ + "static/media/icon-step-six.11324661.png";